export const MINIATURE = `miniature`;
export const GALLERY = `gallery`;
export const LIST = `list`;
export const displayEnum = {
  miniature: 'Miniatura',
  list: 'Lista',
  gallery: 'Galeria'
};
export const INTEREST_FREE_LABEL = 'sem juros';
export const MAGALU_DOMAIN = 'https://www.magazineluiza.com.br';
export const productImageSizes = {
  width: '186',
  height: '140'
};
export const DEFAULT_SELLER = 'magazineluiza';
export const LABEL_SHOW_FULL_LIST = 'Descubra outras ofertas aqui';
export const ICON_SHOW_FULL_LIST = {
  endIcon: 'ChevronRight',
  justifyContent: 'flex-start'
};
export const LABEL_SHOW_MORE = 'Mostrar mais produtos';
export const ICON_SHOW_MORE = {
  startIcon: 'ChevronDownCircle',
  centered: true
};
export const NATIONAL_CURRENCY = 'BRL';